import classNames from 'classnames';

import Icon from './Icon';
import InvalidFeedback from './InvalidFeedback';

type PropsFormikInputWrapper = {
  id?: string;
  name?: string;
  label?: string;
  icon?: string;
  idIcon?: string;
  swap?: boolean;
  iconProps?: object;
  idFeedback?: string;
  prevText?: string;
  nextText?: string;
  containerClass?: string;
  meta?: {
    touched?: boolean,
    error?: string
  },
  children: JSX.Element;
  placeholder?: string;
  ariaDescribedby?: string;
}

export function FormikInputWrapper(
  {
    label,
    id,
    icon,
    idIcon,
    swap = false,
    iconProps = {},
    idFeedback,
    prevText,
    nextText,
    meta: {
      touched,
      error
    } = {},
    containerClass,
    children
  }: PropsFormikInputWrapper
) {
  return (
    <>
      {label && (
        <label
          htmlFor={id}
          className="form-label"
        >
          {label}
        </label>
      )}

      <div className={classNames('input-group has-validation', containerClass)}>
        {(icon && swap) && (
          <span
            className="input-group-text"
            id={idIcon}
          >
            <Icon
              icon={icon}
              {...iconProps}
            />
          </span>
        )}
        {prevText && (
          <span className="input-group-text">
            {prevText}
          </span>
        )}

        {children}

        {nextText && (
          <span className="input-group-text">
            {nextText}
          </span>
        )}
        {(icon && !swap) && (
          <span
            className={classNames('input-group-text', touched && error && 'border border-danger')}
            id={idIcon}
          >
            <Icon
              icon={icon}
              {...iconProps}
            />
          </span>
        )}
        <InvalidFeedback
          id={idFeedback}
          message={(touched && error) ? error : ''}
        />
      </div>
    </>
  );
}

export default FormikInputWrapper;
